export const META = {
  titleSeparator: '-',
  siteName: 'MapleStory Universe Explorer',
  description: 'Discover the on-chain information of the Henesys L1 through the MapleStory Universe Explorer.',
  keywords: '', // temp
  chain: 'Nexon',
}
